import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {FileField, FieldReturn} from '../../types'

export const file = (props?: FileField, mergeProps?: Partial<FileField>): FieldReturn =>
  field('file', mergeConfig('file', props, mergeProps))
